import type { Quote as QuoteType } from 'types/capi/content';

type Props = {
  quote: QuoteType;
};

const Quote = ({ quote }: Props) => {
  return (
    <blockquote className="mx-auto my-5 block w-full px-4 text-center font-sans text-2xl font-light uppercase">
      {quote.speech_marks && '“'}
      {quote.text}
      {quote.speech_marks && '”'}
    </blockquote>
  );
};

export default Quote;
